import { Component, OnInit } from '@angular/core';
import { MediaFile } from '../../models/media-file.model';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
export enum FileType {
  PDF = 'pdf',
  Image = 'image'
}
@Component({
  selector: 'app-view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.scss']
})
export class ViewFileComponent implements OnInit {
  isLoading = true;
  file?: MediaFile;
  fileType?: FileType;
  isError = false;


  constructor(
    private dialogConfig: DynamicDialogConfig,
  ) { }

  ngOnInit(): void {
    this.isError = false;
    this.file = this.dialogConfig.data?.file;
    this.fileType = this.getFileType(this.file?.url);
    if (!this.fileType) {
      this.isLoading = false;
    }
    if (this.fileType === FileType.PDF) {
      this.isLoading = false;
    }
  }

  getFileExtension(url?: string): string | undefined {
    if (!url) {
      return undefined;
    }
    const ext = url.split('.').pop()?.toLowerCase();
    return ext ? ext : undefined;
  }

  getFileType(url?: string): FileType | undefined {
    if (!url) {
      return undefined;
    }
    const ext = url.split('.').pop()?.toLowerCase();
    if (!ext) {
      return undefined;
    }
    switch (ext) {
      case 'pdf':
        return FileType.PDF;
      case 'png':
      case 'jpg':
      case 'jpeg':
        return FileType.Image;
      default:
        return undefined;
    }
  }

  onPdfError() {
    this.isLoading = false;
    this.isError = true;
  }

  download(url?: string) {
    if (!url) {
      return;
    }
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', url);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  protected readonly FileType = FileType;
}
